import { useSelector } from "react-redux";
import { isUserTemPermissao } from "../utils";
import { perfis } from "./global";
import { useEffect } from "react";

const Menu = () => {
  const user = useSelector((state) => state.userReducer.user);
  const menuReducer = useSelector((state) => state.MenuReducer);

  const isUserTemPerssao = (routePerfil) => {
    return isUserTemPermissao(routePerfil, perfis, user.contaAcesso.authorities);
  };

  useEffect(() => {
    montarMenu();
  }, [menuReducer.menu]);

  function montarMenu() {
    let rootMenu = [{ label: "Pagina Inicial", icon: "pi pi-home", to: "/" }];
    let items = [];

    //setContaAcesso(getContaAcesso())
    if (user) {
      if (menuReducer.menu === 1) {
        if (isUserTemPerssao("monitora")) {
          rootMenu.push({
            label: "Monitoramento",
            icon: "pi pi-fw pi-briefcase",
            items,
          });
        }

        if (isUserTemPerssao("lancamentos")) {
          items.push({ label: "Lançamento de Dados", icon: "pi pi-fw pi-home", to: "/monlancamentos" });
        }

        if (isUserTemPerssao("permissaoUsuario")) {
          items.push({ label: "Permissão PTA", icon: "pi pi-fw pi-cog", to: "/monpermissoes" });
        }

        if (isUserTemPerssao("cadastroExercicioPTAMonitora")) {
          items.push({ label: "Cadastro Exercícios", icon: "pi pi-fw pi-tags", to: "/exercicio" });
        }
        if (isUserTemPerssao("relatorio")) {
          let itensrelatorio = [];
          if (isUserTemPerssao("relatorioPermissoes")) {
            itensrelatorio.push({ label: "Permissões Monitora", icon: "pi pi-fw pi-tags", to: "/relatoriopermissoes" });
          }
          if (isUserTemPerssao("relatorioRestricaoItensMonitoraveis")) {
            itensrelatorio.push({
              label: "Restrição Itens Monitoráveis",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriorestricaoitensmonitoraveis",
            });
          }
          if (isUserTemPerssao("relatorioExecFisicaSintetico")) {
            itensrelatorio.push({
              label: "Execução Física Sintético",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioexecfisicasintetico",
            });
          }

          if (isUserTemPerssao("relatorioExecFisicaAnalitico")) {
            itensrelatorio.push({
              label: "Execução Física Analítico",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioexecfisicaanalitico",
            });
          }

          if (isUserTemPerssao("relatorioFinaceiroSinteticoAcao")) {
            itensrelatorio.push({
              label: "Execução Financeira Sintético",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriofinanceirosinteticoacao",
            });
          }

          if (isUserTemPerssao("relatorioFinanceiroAnalitico")) {
            itensrelatorio.push({
              label: "Execução Financeira Analítica",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriofinanceiroanalitico",
            });
          }

          if (isUserTemPerssao("relatorioBaseGeral")) {
            itensrelatorio.push({ label: "Base Geral", icon: "pi pi-fw pi-tags", to: "/relatoriobasegeral" });
          }

          if (isUserTemPerssao("relatorioMonitoraConsolidado")) {
            itensrelatorio.push({
              label: "Consolidado",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriomonitoraconsolidado",
            });
          }

          // if (isUserTemPerssao("relatorioStatusExecucao")) {
          //   itensrelatorio.push({
          //     label: "Status de Execução",
          //     icon: "pi pi-fw pi-tags",
          //     to: "/relatoriostatusexecucao",
          //   });
          // }

          if (isUserTemPerssao("relatorioIndicadoresAcao")) {
            itensrelatorio.push({
              label: "Indicadores de Ação",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioindicadoresacao",
            });
          }

          items.push({
            label: "Relatórios",
            icon: "pi pi-fw pi-briefcase",
            items: [...itensrelatorio],
          });
        }
      }

      if (menuReducer.menu === 2) {
        if (isUserTemPerssao("lancamentoRag")) {
          items.push({ label: "Lançamentos", icon: "pi pi-fw pi-tags", to: "/raglancamentos" });
        }

        if (isUserTemPerssao("permissaoLancamentoRag")) {
          items.push({ label: "Permissões", icon: "pi pi-fw pi-cog", to: "/ragpermissoes" });
        }

        if (isUserTemPerssao("ExercicioRag")) {
          items.push({ label: "Cadastro de Exercícios", icon: "pi pi-fw pi-tags", to: "/ragexercicios" });
        }

        if (isUserTemPerssao("relatorio")) {
          let itensrelatorio = [];
          if (isUserTemPerssao("relatorioAnalitico")) {
            itensrelatorio.push({
              label: "Consolidado por Programa",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioconsolidado",
            });
          }

          if (isUserTemPerssao("relatorioAnaliticoProgramaAcao")) {
            itensrelatorio.push({
              label: "Consolidado por Programa e Ação",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioconsolidadoprogacao",
            });
          }

          if (isUserTemPerssao("RelatorioBaseGeralPrograma")) {
            itensrelatorio.push({
              label: "Base Geral Programa",
              icon: "pi pi-fw pi-tags",
              to: "/relatorio-base-geral-programa",
            });
          }

          if (isUserTemPerssao("RelatorioBaseGeralAcao")) {
            itensrelatorio.push({
              label: "Base Geral Acão",
              icon: "pi pi-fw pi-tags",
              to: "/relatorio-base-geral-acao",
            });
          }

          if (isUserTemPerssao("RelatorioSugestaoMelhoria")) {
            itensrelatorio.push({
              label: "Sugestão Melhoria",
              icon: "pi pi-fw pi-tags",
              to: "/relatorio-sugestao-melhoria",
            });
          }


          if (isUserTemPerssao("RelatorioProrrogacao")) {
            itensrelatorio.push({
              label: "Prorrogações",
              icon: "pi pi-fw pi-tags",
              to: "/relatorio-prorrogacoes",
            });
          }

          if (isUserTemPerssao("RelatorioApuracaoIndicadorProgramaAcao")) {
            itensrelatorio.push({
              label: "Apuraçao do Indicador Programa e Acão",
              icon: "pi pi-fw pi-tags",
              to: "/relatorio-apuracao-indicador-programa-acao",
            });
          }

          if (isUserTemPerssao("relatorioExecucaoFisicaProdutoAcao")) {
            itensrelatorio.push({
              label: "Execução Física do Produto da Ação",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioexecfisica",
            });
          }

          if (isUserTemPerssao("relatorioApuracaoIndicadorPrograma")) {
            itensrelatorio.push({
              label: "Apuração do Indicador do Programa",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioapuracaoindicador",
            });
          }

          if (isUserTemPerssao("relatorioPendencia")) {
            itensrelatorio.push({
              label: "Pendência de Preenchimento",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriopendencia",
            });
          }

          if (isUserTemPerssao("relatorioPermissaoRag")) {
            itensrelatorio.push({
              label: "Relatórios Permissão",
              icon: "pi pi-fw pi-tags",
              to: "/relatoriopermissao",
            });
          }

          if (isUserTemPerssao("relatorioAnaliseDevolutiva")) {
            itensrelatorio.push({
              label: "Análise/Devolutiva",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioanalisedevol",
            });
          }

          if (isUserTemPerssao("relatorioOdsPublicoTransversal")) {
            itensrelatorio.push({
              label: "ODS e Público Transversal",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioodspublico",
            });
          }

          if (isUserTemPerssao("relatorioExecucaoOrcamentariaAcao")) {
            itensrelatorio.push({
              label: "Execução Orçamentária e Financeira da Ação",
              icon: "pi pi-fw pi-tags",
              to: "/relatorioexecorcamacao",
            });
          }

          items.push({
            label: "Relatórios",
            icon: "pi pi-fw pi-briefcase",
            items: [...itensrelatorio],
          });
        }

        if (isUserTemPerssao("rag")) {
          rootMenu.push({
            label: "RAG",
            icon: "pi pi-fw pi-briefcase",
            items,
          });
        }
      }

      items = [];

      if (menuReducer.menu === 0 || menuReducer.menu === 1 || menuReducer.menu === 2) {
        if (isUserTemPerssao("seguranca")) {
          if (isUserTemPerssao("cadastroUsuario")) {
            items.push({ label: "Cadastro Usuario", icon: "pi pi-fw pi-user-edit", to: "/usuarios" });
          }
          /*if(this.isUserTemPerssao('cadastroPerfilUsuario')){
              items.push({label: 'Cadastro Perfil', icon: 'pi pi-fw pi-sitemap', to: '/monitoraRag/seguranca/cadastro/perfil'})
          }*/

          rootMenu.push({
            label: "Segurança",
            icon: "pi pi-fw pi-briefcase",
            items,
          });
        }
        items = [];
      }
    }

    return rootMenu;
  }

  return montarMenu();
};

export default Menu;
